var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',[(_vm.smsData)?_c('marketing-sms-form',{attrs:{"item":_vm.smsData,"view":""}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }